/** This bundle's build id (`YYYYMMDDHHMMSS`); empty on the dev server, which turns the handshake off. */
export const CLIENT_BUILD = import.meta.env.PREA_BUILD ?? "";
